import Box from "@mui/joy/Box";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useState } from "react";
import styles from "./Carousel.module.css";
import { isUrl } from "../../utils/misc";
import { AspectRatio, Chip, IconButton, Typography } from "@mui/joy";
import { theme } from "../Theme";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";

type Params = {
  alt: string;
  options?: EmblaOptionsType;
  slides: string[];
  businessId: string;
  onClick?: (image?: string) => void;
};

export default function ProductCarousel({
  alt,
  options,
  slides,
  businessId,
  onClick,
}: Params) {
  const [emblaRef, embla] = useEmblaCarousel(options);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (embla) {
      embla.on("select", () => {
        console.log(`Current index is ${embla.selectedScrollSnap()}`);
        setCurrentIndex(embla.selectedScrollSnap());
      });
    }
  }, [embla]);

  return (
    <Box>
      <section className={styles.embla2}>
        <div className={styles.embla__viewport} ref={emblaRef}>
          <div
            className={styles.embla__container}
            style={{
              position: "relative",
            }}
          >
            {slides.map((slide, index: any) => (
              <div className={styles.embla__slide} key={index}>
                <div className={styles.embla__slide__number}>
                  <AspectRatio
                    ratio={1}
                    sx={{
                      width: { xs: "185px", lg: "190px", xl: "208px" },
                      height: { xs: "185px", lg: "190px", xl: "208px" },
                    }}
                  >
                    <img
                      alt={alt}
                      src={
                        isUrl(slide)
                          ? slide
                          : `${
                              import.meta.env.VITE_API_URL
                            }/objects/${businessId}/${slide}`
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      onError={(e) => {
                        (e.target as HTMLImageElement).src =
                          "/inventory-img-placeholder.png";
                      }}
                    />

                    {slides.length ? (
                      <Chip
                        sx={{
                          position: "absolute",
                          backgroundColor:
                            theme.palette.others.carousel_index_bg,
                          bottom: { xs: "4%", xl: "4%" },
                          left: { xs: "4%", xl: "4%" },
                          zIndex: 100,
                          py: "4px",
                          px: "8px",
                          borderRadius: "4px",
                        }}
                      >
                        <Typography level="text-xs-regular">
                          {currentIndex + 1}/{slides.length}
                        </Typography>
                      </Chip>
                    ) : null}

                    {onClick && (
                      <IconButton
                        size="sm"
                        sx={{
                          position: "absolute",
                          bottom: "4%",
                          right: "4%",
                          zIndex: 50,
                          p: "2px",
                          backgroundColor: theme.palette.common.white,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          onClick?.();
                        }}
                      >
                        <ArrowsPointingOutIcon width={20} height={20} />
                      </IconButton>
                    )}
                  </AspectRatio>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Box>
  );
}
